import { render, staticRenderFns } from "./menu-vertical.component.vue?vue&type=template&id=4b0e025e&scoped=true"
import script from "./menu-vertical.component.vue?vue&type=script&lang=js"
export * from "./menu-vertical.component.vue?vue&type=script&lang=js"
import style0 from "./menu-vertical.component.vue?vue&type=style&index=0&id=4b0e025e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e025e",
  null
  
)

export default component.exports